export default "__VITE_ASSET__d9be8986__"